import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {/* Brand */}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading mb-4">
              黑料吃瓜网
            </h2>
            <p className="text-foreground-300 text-sm leading-relaxed mb-6 max-w-xs">
              全网领先的娱乐爆料平台，实时追踪网红明星塌房现场与每日大赛独家吃瓜爆料。十年娱记团队，一线资源支持。
            </p>
            <div className="flex items-center gap-3">
              <a
                href="http://obyqdiy.cn/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-lg" />
              </a>
              <a
                href="http://obyqdiy.cn/heiliao"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors"
                aria-label="微信公众号"
              >
                <i className="ri-wechat-line text-lg" />
              </a>
              <a
                href="http://obyqdiy.cn/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors"
                aria-label="抖音"
              >
                <i className="ri-tiktok-line text-lg" />
              </a>
              <a
                href="mailto:hello@obyqdiy.cn"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors"
                aria-label="邮件"
              >
                <i className="ri-mail-line text-lg" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <div>
              <h3 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-2">
                爆料投稿
              </h3>
              <p className="text-sm text-foreground-200">hello@obyqdiy.cn</p>
              <p className="text-sm text-foreground-200">24小时接收独家线索</p>
            </div>
            <div>
              <h3 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-2">
                商务合作
              </h3>
              <p className="text-sm text-foreground-200">hello@obyqdiy.cn</p>
              <p className="text-sm text-foreground-200">010-8888-6666</p>
            </div>
            <div>
              <h3 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-2">
                办公地址
              </h3>
              <p className="text-sm text-foreground-200">北京市朝阳区建国路88号</p>
              <p className="text-sm text-foreground-200">SOHO现代城A座 1806室</p>
            </div>
          </div>

          {/* Image + Quick Links */}
          <div className="flex flex-col gap-6">
            <div className="w-full h-40 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20urban%20cityscape%20at%20night%20with%20neon%20lights%20and%20tall%20buildings%2C%20Beijing%20skyline%20atmosphere%2C%20dark%20with%20warm%20red%20and%20gold%20accents%2C%20cinematic%20editorial%20photography&width=400&height=300&seq=footer-img&orientation=landscape"
                alt="黑料吃瓜网办公城市夜景"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex flex-wrap gap-x-6 gap-y-2">
              <Link
                to="/"
                className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap"
              >
                首页
              </Link>
              <Link
                to="/category/wanghong-tafang"
                className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap"
              >
                网红塌房
              </Link>
              <Link
                to="/category/mingxing-heiliao"
                className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap"
              >
                明星黑料
              </Link>
              <Link
                to="/about"
                className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap"
              >
                关于我们
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 px-4 md:px-8 py-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-400">
            &copy; 2026 黑料吃瓜网 版权所有 | 京ICP备2026666666号
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/about"
              className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors"
            >
              关于我们
            </Link>
            <a
              href="#"
              className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors"
            >
              免责声明
            </a>
          </div>
        </div>
      </div>

      {/* Organization JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "黑料吃瓜网",
          url: "http://obyqdiy.cn/",
          logo: "http://obyqdiy.cn/logo.png",
          description: "全网领先的娱乐爆料平台，实时追踪网红明星塌房现场与独家吃瓜爆料",
          sameAs: [
            "http://obyqdiy.cn/",
          ],
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "爆料投稿",
            email: "hello@obyqdiy.cn",
            telephone: "+86-10-8888-6666",
            areaServed: "CN",
            availableLanguage: "Chinese",
          },
        })}
      </script>
    </footer>
  );
}
